export enum HomeComponentType {
  LandingWidget = 'LandingWidget',
  RatingWidget = 'RatingWidget',
  StackCard = 'StackCard',
  ProductBanner = 'ProductBanner',
  CouponUnlockBanner = 'CouponUnlockBanner',
  DownloadAppBanner = 'DownloadAppBanner',
}
